module.exports = __webpack_public_path__ + "static/img/img-delete.50fbea4e.png";